import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/user-group';
const userGroupList = () => {
	return Client.get('/admin/api/user-group');
};
const userGroupListCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}`);
};

const newGroup = (group) => {
	return Client.post('/admin/api/user-group', group);
};
const newGroupCloud = (merchantId, branchId, group) => {
	return Client.post(`${numbatUrl}/${merchantId}/${branchId}`, group);
};

const userGroup = (groupName) => {
	return Client.get(`/admin/api/user-group/${groupName}`);
};
const userGroupCloud = (merchantId, branchId, groupName) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/${groupName}`);
};
const updateUserGroup = (name, targetGroup) => {
	return Client.put(`/admin/api/user-group/${name}`, targetGroup);
};
const updateUserGroupCloud = (merchantId, branchId, name, targetGroup) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/${name}`,
		targetGroup
	);
};
const removeGroup = (groupName) => {
	return Client.del(`/admin/api/user-group/${groupName}`);
};
const removeGroupCloud = (merchantId, branchId, groupName) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${groupName}`);
};
export default {
	userGroupList,
	newGroup,
	userGroup,
	updateUserGroup,
	removeGroup,
	userGroupListCloud,
	userGroupCloud,
	updateUserGroupCloud,
	newGroupCloud,
	removeGroupCloud,
};
